import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { styled } from "styled-components";
import { useLocation, useNavigate } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";

// utils
import { backIncstance, imgUpload } from "../utils/commonFunctions";
import { MyContext } from "../context/MyContext";
import { getLoginInfo } from "../utils/commonFunctions"; // 240627
// icons
import Plus from "../assets/icons/icon_plus.png";
// import Logo from '../assets/icons/icon_logo.svg';
import Toggle from "../assets/icons/icon_toggle.png";
import Edit from "../assets/icons/icon_edit.png";
import Delete from "../assets/icons/icon_del.png";
import Save from "../assets/icons/icon_save.png";
import More from "../assets/icons/icon_more.png";
import Alert from "./Alert";
import OpenNav from "../assets/icons/icon_nav_plain.png";
import ProfileImg from "../assets/icons/icon_profile_pc.png";
import Settings from "../assets/icons/icon_settings.png";
import History from "../assets/icons/icon_history.png";
import Storage from "../assets/icons/icon_storage.png";
import MyPage from "../assets/icons/icon_mypage.png";
import MyActivity from "../assets/icons/icon_air_activities.png";
import Login from "../assets/icons/icon_login.png";
import Products from "../assets/icons/icon_coin.png";
import Warning from "./Warning";
import Fetching from "./Fetching";
import GuideIcon from "../assets/icons/icon_guide_m.png";
import FooterSide from "./FooterSide";
import CONSTANTS from "../constants";
import TicketAlert from "./TicketAlert";
import socratesApi from "../api/socratesApi";

/**
 * 네비게이션 기능
 * 1. pathname값에 따라 채팅목록/채팅 보관함 목록 호출
 * 2. 제목 변경, 리스트 삭제시 API 호출하고 새로운 목록 호출
 */
const URLS = {
  BASRE_URL: process.env.REACT_APP_BASE_URL,
  CLARIO: process.env.REACT_APP_CLARIO_SERVER,
  UPDATE_PROFILE: process.env.REACT_APP_MYPAGE_UPDATE_PROFILE,
  LOGOUT: process.env.REACT_APP_LOGOUT_URL,
};

const TUTOR_URLS = {
  GROUP_LIST: process.env.REACT_APP_TUTOR_GET_GROUP_LIST,
  EDIT_LIST: process.env.REACT_APP_TUTOR_EDIT_GROUP_LIST,
  CHAT_HISTORY: process.env.REACT_APP_TUTOR_GET_HISTORY_LIST,
  STORAGE_LIST: process.env.REACT_APP_TUTOR_GET_STORAGE_LIST,
  EDIT_STORAGE: process.env.REACT_APP_TUTOR_EDIT_STORAGE_LIST,
  HISTORY: process.env.REACT_APP_TUTOR_GET_STOARGE_GROUP_LIST,
};
const SOCRATES_URLS = {
  GROUP_LIST: process.env.REACT_APP_SOCRATES_GET_GROUP_LIST,
  EDIT_LIST: process.env.REACT_APP_SOCRATES_EDIT_GROUP_LIST,
  CHAT_HISTORY: process.env.REACT_APP_SOCRATES_GET_HISTORY_LIST,
  STORAGE_LIST: process.env.REACT_APP_SOCRATES_GET_STORAGE_LIST,
  EDIT_STORAGE: process.env.REACT_APP_SOCRATES_EDIT_STORAGE_LIST,
  HISTORY: process.env.REACT_APP_SOCRATES_GET_STOARGE_GROUP_LIST,
};
const SETTINGS = [
  {
    NAME: "로그인/회원가입",
    LINK: "/login",
    ICON: null,
    ISLOGO: false,
  },
  {
    NAME: "마이페이지",
    LINK: "/my-activity",
    ICON: null,
    ISLOGO: false,
  },
];

const HOVER_OPTIONS = [
  {
    ICON: Edit,
    NAME: "제목 변경",
    EVENT: "edit",
  },
  {
    ICON: Delete,
    NAME: "삭제",
    EVENT: "delete",
  },
  {
    ICON: Save,
    NAME: "이력 보관",
    EVENT: "save",
  },
];

const MENU_LIST = [
  {
    NMAE: "나의 활동",
    PATH: "/my-activity",
    PARAM: "my-activity",
  },
  {
    NMAE: "역할/어투 설정",
    PATH: "/settings/persona",
    PARAM: "persona",
  },
  {
    NMAE: "이용 내역",
    PATH: "/settings/order-list",
    PARAM: "order-list",
  },
];
const Nav = (props) => {
  const {
    user,
    history,
    setHistory,
    setUser,
    storedList,
    isStartInterview,
    setIsAddingMode,
    setIsLogin,
    setStoredList,
    pageName,
    isMobile,
    openNav,
    setOpenNav,
    list,
    setList,
    paramId,
    setParamId,
    fetching,
    alertModal,
    setAlertModal,
    alertSetting,
    setAlertSetting,
    isProfile,
    isLogin,
    isUpdateList,
    setIsUpdateList,
    headerRef,
    isAppMode,
    setIsOpenTicketAlert,
  } = useContext(MyContext);
  // const [storedList, setStoredList] = useState([]);
  const navigation = useNavigate();
  const location = useLocation();

  const modalRef = useRef(null);
  const listRef = useRef(Array(list?.length).fill(null));
  const moreRef = useRef(Array(list?.length).fill(null));
  const storedRef = useRef(Array(storedList?.length).fill(null));
  const editRef = useRef(Array(storedList?.length).fill(null));
  const titleRefs = useRef(Array(list?.length).fill(null));
  const storefTitleRefs = useRef(Array(storedList?.length).fill(null));

  const listScrollRef = useRef(null);
  const storageScrollRef = useRef(null);

  const [isShowList, setIsShowList] = useState(false);
  const [isShowRecent, setIsShowRecent] = useState(false);

  const [pathSegments, setPathSegments] = useState([]);

  const [currentUrl, setCurrentUrl] = useState(null);
  const [currentChatState, setCurrentChatState] = useState({
    isChat: false,
    path: null,
  });

  const [listPage, setListPage] = useState({
    offset: 1,
    limit: 10,
    total: null,
  });

  const [storagePage, setStoragePage] = useState({
    offset: 1,
    limit: 100,
    total: null,
  });

  // basePath를 정의 (예: "/tutor")
  // const endpoint = pageName === 'tutor' ? TUTOR_URLS : SOCRATES_URLS;
  const [endpoint, setEndpoint] = useState(TUTOR_URLS);

  // 유효한 로그인 상태인지 확인하는 함수
  const isValidLogin = () => {
    return !!(user && user.id);
  };

  // pageName에 따른 네비게이션 경로 결정
  const getNavigationPath = (currentPageName, chatState = null) => {
    if (currentPageName === "result") {
      return "socrates";
    }
    if (currentPageName === "socrates" || currentPageName === "") {
      return currentPageName;
    }
    // 채팅이 아닌 상태에서 이전 경로가 있으면 그 경로 사용
    if (chatState && !chatState.isChat && chatState.path) {
      return chatState.path;
    }
    return "tutor";
  };

  // 편집 클릭시 상태 변경
  const handleClickItem = (target, e, index) => {
    if (!list && !storedList) return;
    // 외부 클릭시 닫힘
    if (target === "outside") {
      setList((prev) =>
        prev?.map((item, idx) => ({
          ...item,
          isClicked: idx === index ? !item.isClicked : false,
        }))
      );
      setStoredList((prev) =>
        prev?.map((item) => ({
          ...item,
          isClicked: false,
        }))
      );
      return;
    }
    e.preventDefault();
    if (target === "group") {
      setList((prev) =>
        prev?.map((item, idx) => ({
          ...item,
          isClicked: idx === index ? !item.isClicked : false,
        }))
      );
      setStoredList((prev) =>
        prev?.map((item) => ({
          ...item,
          isClicked: false,
        }))
      );
      setTimeout(() => {
        const container = listScrollRef.current; // 스크롤을 이동시킬 컨테이너
        const targetElement = listRef.current[index]; // 클릭된 요소

        if (container && targetElement) {
          // 클릭된 요소의 offsetTop 값에 따라 컨테이너의 스크롤을 이동
          const elementOffsetTop = targetElement.offsetTop;
          const containerHeight = container.clientHeight;
          const elementHeight = targetElement.clientHeight;
          // 클릭된 요소가 컨테이너의 시작 또는 끝에 적당히 위치하도록 조정
          const targetScrollTop = Math.max(
            Math.min(
              elementOffsetTop - containerHeight / 2 + elementHeight / 2,
              container.scrollHeight - containerHeight
            ),
            0
          );

          container.scrollTo({
            top: targetScrollTop,
            behavior: "smooth",
          });
        }
      }, 0);
      return;
    } else {
      setList((prev) =>
        prev.map((item) => ({
          ...item,
          isClicked: false,
        }))
      );
      setStoredList((prev) =>
        prev?.map((item, idx) => ({
          ...item,
          isClicked: idx === index ? !item.isClicked : false,
        }))
      );
      // 스크롤 이동
      setTimeout(() => {
        const container = storageScrollRef.current; // 스크롤을 이동시킬 컨테이너
        const targetElement = storedRef.current[index]; // 클릭된 요소

        if (container && targetElement) {
          // 클릭된 요소의 offsetTop 값에 따라 컨테이너의 스크롤을 이동
          const elementOffsetTop = targetElement.offsetTop;
          const containerScrollTop = container.scrollTop;
          const containerHeight = container.clientHeight;

          // 요소가 컨테이너 상단에 위치하도록 스크롤 조정
          container.scrollTo({
            top: containerScrollTop + elementOffsetTop - containerHeight / 2,
            behavior: "smooth",
          });
        }
      }, 0);
      return;
    }
  };

  // 모든 아이템의 클릭 상태를 false로 설정
  const resetItemClicked = () => {
    setList((prev) =>
      prev.map((item) => ({
        ...item,
        isClicked: false,
        isEdit: false,
      }))
    );
    setStoredList((prev) =>
      prev.map((item, idx) => ({
        ...item,
        isClicked: false,
        isEdit: false,
      }))
    );
    return;
  };

  const handleClickLink = (target, item, openNewWindow) => {
    if (openNewWindow) {
      window.open(`${window.location.origin}${item}`, "_blank");
      return;
    }

    if (target === "동아사이언스") {
      setOpenNav(!openNav);
    } else {
      // alert('서비스 준비중입니다.')
      setOpenNav(false);
      navigation(item, {
        state: {
          from_chat: null,
          is_writed: false,
          is_completed: false,
          his_cnt: 0,
        },
      });
    }
  };

  // 외부 클릭시 열려있는 모달창 및 네비게이션 창 닫기(모바일)
  const handleOutsideClick = (e) => {
    e.stopPropagation();
    // 모바일 하단 네비게이션 클릭시 이벤트 중복 방지
    if (e.target.closest(".mo-menu")) {
      return;
    }

    // 모바일: 사이드 메뉴 외부(빈 배경) 클릭 시 메뉴 닫기 - 최우선 처리
    if (
      isMobile &&
      openNav &&
      modalRef.current &&
      !modalRef.current.contains(e.target)
    ) {
      // 헤더 영역 클릭은 제외
      if (headerRef?.current?.contains(e.target)) return;
      setOpenNav(false);
      return;
    }

    if (!list && !storedList) return;
    if (headerRef?.current?.contains(e.target)) return;
    if (moreRef?.current?.some((ref) => ref?.contains(e.target))) return;
    if (editRef?.current?.some((ref) => ref?.contains(e.target))) return;
    // 추가
    if (e.target?.id !== "chat-more-btn") {
      if (e.target?.parentElement?.id !== "chat-more-btn-title") {
        handleClickItem("outside");
      }
    }

    const isOpen = list?.some((item) =>
      item.isClicked === true ? true : false
    );
    const isEdit = list?.some((item) => (item.isEdit === true ? true : false));
    const isStoreOpen = storedList?.some((item) =>
      item.isClicked === true ? true : false
    );
    const isStoreEdit = storedList?.some((item) =>
      item.isEdit ? true : false
    );

    // moreRef: 채팅 목록, editRef: 채팅 보관함
    if (
      !isMobile &&
      isOpen &&
      editRef?.current?.some((ref) => ref?.contains(e.target))
    ) {
      // 모든 moreRef 외부 클릭
      if (isEdit) return;
      resetItemClicked();
      return;
    }

    if (
      isMobile &&
      isStoreOpen &&
      editRef?.current &&
      !editRef?.current.contains(e.target)
    ) {
      setOpenNav(false);
      return;
    } else if (!isMobile && isStoreOpen) {
      // 모든 moreRef 외부 클릭
      if (isStoreEdit) return;
      // resetItemClicked();
      return;
    }
    return;
  };

  const [loading, setLoading] = useState(false);
  /**
   * 함수명: touchAPI
   * 기능: API 전체 관리
   * 처리: url 주소 별로 요청 성공시 이벤트 분기
   * @param {메소드} method
   * @param {API 주소} url
   * @param {요청 데이터} data
   */

  const touchAPI = async (method, url, data) => {
    if (!isValidLogin()) {
      return;
    }

    setLoading(true);
    try {
      const response = await backIncstance(method, url, data);
      let basePath = `/${pathSegments[1]}`;
      // if (basePath === '/result') return
      if (response.status === 200 || response.status === 201) {
        const resData = await response?.json();
        return resData;
      } else if (response.status === 401) {
        setIsLogin(true);
        return;
      } else {
        const text =
          endpoint.EDIT_STORAGE === url &&
          method === "POST" &&
          response.status === 400
            ? "이미 보관함에 저장된 대화입니다."
            : "다시 시도해주세요.";
        if (url === endpoint.EDIT_STORAGE && method === "POST") {
          setAlertSetting((prev) => ({
            ...prev,
            alertTxt: text,
            btnTxt: "닫기",
          }));
        }
      }
    } catch (err) {
      setAlertSetting((prev) => ({
        ...prev,
        alertTxt: `서버 오류입니다.\n관리자에게 문의 바랍니다.`,
        btnTxt: "닫기",
      }));
    } finally {
      setLoading(false);
    }
  };

  // 새 채팅 생성은 최근 채팅 목록에만 생성 가능
  const addList = async () => {
    if (
      (user.tutor_cnt === 0 && endpoint.EDIT_LIST === TUTOR_URLS.EDIT_LIST) ||
      (user.socra_cnt === 0 && endpoint.EDIT_LIST === SOCRATES_URLS.EDIT_LIST)
    ) {
      setIsOpenTicketAlert(true);
      return;
    }

    const url = endpoint.EDIT_LIST;
    const reqData = {
      // user_pk: user.id,
      title: "새 대화",
    };
    const addData = await touchAPI("POST", url, reqData);
    if (addData) {
      getGroupList(endpoint.GROUP_LIST);
      // navigation 경로를 결정
      const navigationPath = getNavigationPath(pageName, currentChatState);
      navigation(`${navigationPath}/${addData.id}`, {
        state: {
          from_chat: addData.from_chat,
          is_writed: false,
          is_completed: false,
          his_cnt: 0,
          add_mode: true,
        },
      });
      setIsAddingMode(true);
      if (navigationPath === "socrates") {
        setIsAddingMode(true);
      }
    }
  };
  const handleLeave = (e) => {
    const data = location.pathname.split("/");

    const params = data[2];
    const page = data[1];
    const mode = location.state;

    const isGroupchat = mode === "group" ? true : false;
    const currentItem = list?.find((elem) => elem.id === Number(params));
    const isCompleted = currentItem?.is_completed;

    if (page === "socrates") {
      // 사용량 체크
      if (user.socra_cnt === 0) {
        setIsOpenTicketAlert(true);
        return;
      }
      if (params && isStartInterview && !isCompleted) {
        setAlertSetting((prev) => ({
          ...prev,
          btnTxt: "중단하고 나가기",
          alertTxt: `페이지를 나가면 면접이 중단됩니다.\n 면접을 끝까지 완료하셔야 평가 리포트를 볼 수 있습니다.`,
          double: true,
          onConfirm: () => {
            if (typeof prev.onConfirm === "function") {
              prev.onConfirm();
            }
            navigation("/socrates/new");
          },
        }));
        return;
      }
      // 소크라테스: ID 생성 없이 폼 페이지로 이동
      navigation("/socrates/new");
      return;
    }
    addList();
    setOpenNav(false);
  };

  const moveToLogin = () => {
    if (!isValidLogin()) {
      window.location.assign(
        `${process.env.REACT_APP_LOGIN_URL}/?referer_url=${process.env.REACT_APP_REFERER_URL}/tutor`
      );
    }
  };

  // 채팅 리스트 편집, 삭제
  const handleEditList = async (type, item, mode, index) => {
    if (fetching) return;
    const targetNm = mode.EVENT;
    const id = item.id;
    if (targetNm === "edit") {
      if (type === "group") {
        setList((prev) => {
          const copy = [...prev];
          copy[index].isEdit = true;
          copy[index].isClicked = false;
          return copy;
        });
        setTimeout(() => {
          if (titleRefs.current[index]) {
            titleRefs.current[index].focus();
          }
        }, 0);

        return;
      } else {
        setStoredList((prev) => {
          const copy = [...prev];
          copy[index].isEdit = true;
          copy[index].isClicked = false;
          return copy;
        });
        setTimeout(() => {
          if (storefTitleRefs.current[index]) {
            storefTitleRefs.current[index].focus();
          }
        }, 0);

        return;
      }
    } else if (targetNm === "delete") {
      // > handleEditList('group', newItem, hoverItem, newIdx)}
      let basePath = `/${pathSegments[1]}`;

      if (
        pathSegments.length > 2 &&
        pathSegments[2].match(/^[0-9]+-[A-Z0-9]+$/)
      ) {
      } else {
        basePath =
          basePath === "/socrates" || basePath === "/result"
            ? "/socrates"
            : "/tutor";
      }

      const onConfirmDelete = async () => {
        const deleteData = await touchAPI(
          "DELETE",
          type === "group" ? endpoint.EDIT_LIST : endpoint.EDIT_STORAGE,
          `/${id}`
        );
        if (deleteData) {
          if (id === Number(pathSegments[2])) {
            setHistory([]);
            navigation(basePath, {
              state: {
                from_chat: type,
                is_writed: false,
                is_completed: false,
                his_cnt: 0,
              },
            });
          }
          setAlertModal(false);
          getGroupList(endpoint.GROUP_LIST);
          getStorageList(endpoint.STORAGE_LIST);
        }
      };
      setAlertSetting((prev) => ({
        ...prev,
        btnTxt: "삭제하기",
        alertTxt: "대화 목록을 삭제하시겠습니까?",
        double: true,
        onConfirm: () => {
          if (typeof prev.onConfirm === "function") {
            prev.onConfirm();
          }
          onConfirmDelete();
        },
      }));
    } else {
      const myHistory = list.find((listed) => listed.id === item.id);
      if (pageName === "tutor") {
        const reqData = {
          user_pk: user.id,
          group_id: Number(id),
          title: myHistory?.title ? myHistory?.title : "보관된 대화",
        };
        const storageData = await touchAPI(
          "POST",
          TUTOR_URLS.EDIT_STORAGE,
          reqData
        );
        if (storageData) {
          getStorageList(TUTOR_URLS.STORAGE_LIST);
          setAlertSetting((prev) => ({
            ...prev,
            alertTxt: "이력이 보관되었습니다.",
          }));
        }
      } else {
        if (item.is_completed) {
          const reqData = {
            group_id: myHistory.id,
            title: myHistory?.title ? myHistory?.title : "보관된 대화",
          };
          const storageData = await touchAPI(
            "POST",
            SOCRATES_URLS.EDIT_STORAGE,
            reqData
          );
          if (storageData) {
            getStorageList(SOCRATES_URLS.STORAGE_LIST);
            setAlertSetting((prev) => ({
              ...prev,
              alertTxt: "이력이 보관되었습니다.",
            }));
          }
        } else {
          setAlertSetting((prev) => ({
            ...prev,
            alertTxt: "면접을 완료한 후 저장 할 수 있습니다.",
          }));
          return;
        }
      }
    }
  };
  const EMPTY = /^\s*$/;
  // 엔터키 입력시 질문 전송
  const checkKeyType = async (target, e, idx, item) => {
    const keyName = e.key;
    const isEmpty = EMPTY.test(e.target.value);
    if (e.nativeEvent.isComposing || isEmpty) return;
    if (keyName === "Enter") {
      e.preventDefault();
      handleBlur(target, e, idx, item);
    }
  };
  // 제목 편집시 블러 상태이면 저장
  const handleBlur = async (target, e, idx, item) => {
    // const newValue = e.target.value;
    const isGroupchat = target === "group" ? true : false;
    const newValue = isGroupchat
      ? titleRefs.current[idx].value
      : storefTitleRefs.current[idx].value;
    const editData = {
      group_id: item.id,
      title: newValue,
    };
    const storageData = {
      storage_id: item.id,
      title: newValue,
    };
    const updateData = await touchAPI(
      "PATCH",
      isGroupchat ? endpoint.EDIT_LIST : endpoint.EDIT_STORAGE,
      isGroupchat ? editData : storageData
    );
    if (updateData) {
      getGroupList(endpoint.GROUP_LIST);
      getStorageList(endpoint.STORAGE_LIST);
    }
  };
  // 메뉴 클릭시 이동
  const handleClickMenu = (e, item) => {
    e.preventDefault();
    setIsAddingMode(false);
    if (!item.isEdit) {
      navigation(item.PATH, {
        state: {
          from_chat: null,
          is_writed: false,
          is_completed: false,
          his_cnt: 0,
        },
      });
      if (isMobile) {
        setOpenNav(false);
      }
      return;
    }
  };
  // 네비게이션 리스트 클릭시 페이지 이동
  const handleClickNav = (e, mode, item) => {
    e.preventDefault();
    // const data = checkGroupId();
    const data = location.state;
    const params = location.pathname.split("/")[2];
    const isCurrentItem = item.id === Number(params);

    const temp = location.pathname.split("/");

    const tempParmas = temp[2];

    const tempItem = list?.find((elem) => elem.id === Number(tempParmas));
    let page = location?.pathname.split("/")[1];

    // 페이지가 result 면 socrates목록 읽어옴
    if (currentChatState.isChat === false) {
      // 현재 chat 이 아닐 경우 이전의 path 를 확인해서 변경
      page = currentChatState.path;
    }

    if (page === "result" || page === "socrates") {
      page = "socrates";
    } else if (page === "" || page === "guide") {
      // 250715 guide 경우 추가.
      page = "tutor";
    } else {
      page = "tutor"; // 기본값 추가. 250715
    }

    const isGroupchat = mode === "group" ? true : false;
    const currentItem = list?.find((elem) => elem.id === Number(params));
    const isCompleted = currentItem?.is_completed;

    const count = item?.total_his_count ? item?.total_his_count : 0;
    if (params && isStartInterview && !isCompleted) {
      setAlertSetting((prev) => ({
        ...prev,
        btnTxt: "중단하고 나가기",
        alertTxt: `페이지를 나가면 면접이 중단됩니다.\n 면접을 끝까지 완료하셔야 평가 리포트를 볼 수 있습니다.`,
        double: true,
        onConfirm: () => {
          if (typeof prev.onConfirm === "function") {
            prev.onConfirm();
          }
          navigation(`/${page}/${item.id}`, {
            state: {
              from_chat: mode,
              is_completed: isGroupchat ? item?.is_completed : true,
              is_writed: isGroupchat ? item?.is_writed : true,
              his_cnt: count,
              show_result: item?.show_result,
            },
          });
          if (isMobile) {
            setOpenNav(false);
          }
        },
      }));
      return;
    }

    if (!fetching && !item.isEdit) {
      // navigation(`/${pageName}/${item.id}`)
      setParamId(params);
      navigation(`/${page}/${item.id}`, {
        state: {
          from_chat: mode,
          is_completed: item?.is_completed,
          is_writed: item?.is_writed,
          his_cnt: count,
          show_result: item?.show_result,
        },
      });
      if (isMobile) {
        setOpenNav(false);
      }
      return;
    }
  };
  // profile img 업데이트
  const [imageData, setImageData] = useState({
    picture_data: user?.picture_data,
    picture_extension: user?.picture_extension,
  });

  useEffect(() => {
    if (user.picture_data && user.picture_extension) {
      setImageData({
        picture_data: user?.picture_data,
        picture_extension: user?.picture_extension,
      });
    }
  }, [user.picture_data, user.picture_extension]);

  const updateProfile = async (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    let base64String;
    let extension;
    const formData = new FormData();
    formData.append("upload_file", file);

    reader.onloadend = () => {
      base64String = reader.result.replace("data:", "").replace(/^.+,/, "");
      extension = file.type.split("/")[1];

      // Call updateUserProfile or another function to update the user profile with the new image data
    };
    if (file) {
      reader.readAsDataURL(file);
      try {
        const response = await imgUpload("PUT", URLS.UPDATE_PROFILE, formData);
        if (response.status === 200 || response.status === 201) {
          setImageData({
            picture_data: base64String,
            picture_extension: extension,
          });
        } else if (response.status === 401) {
          // setAlertSetting(prev => ({
          //   ...prev,
          //   alertTxt: '로그인이 필요합니다.',
          //   onClose: () => {
          //     clearState()
          //     navigation('/login', { state: { from_chat: null, is_writed: false, is_completed: false, his_cnt: 0 } })
          //   }
          // }))
          setIsLogin(true);
          return;
        }
      } catch (e) {
        setAlertSetting((prev) => ({
          ...prev,
          alertTxt: "다시 시도해주세요.",
          btnTxt: "닫기",
        }));
      }
    }
  };

  const getGroupList = async (url) => {
    // 소크라테스 모드: 새 API 사용
    // URL 파라미터와 현재 경로 모두 확인하여 소크라테스 페이지 여부 판단
    const currentPath = location.pathname.split("/")[1];
    // /socrates, /socrates/*, /result 모두 포함
    const isSocratesPage =
      currentPath === "socrates" || currentPath === "result";
    const isSocratesMode = url === SOCRATES_URLS.GROUP_LIST || isSocratesPage;

    // 소크라테스 페이지에서는 소크라테스 API만 호출
    if (isSocratesMode) {
      // user.id가 없으면 API 호출하지 않음
      if (!user?.id) {
        console.log("[Nav] 소크라테스 모드: user.id 없음, API 호출 스킵");
        return;
      }
      try {
        const interviews = await socratesApi.getUserInterviews(user.id);
        console.log(
          "[소크라테스 V2] API 응답: user.id, interviews",
          user.id,
          interviews
        );

        const newData = (interviews || []).map((item) => ({
          id: item.interviewId,
          title: item.interviewType
            ? `${item.interviewType} - ${item.interviewSubject || "면접"}`
            : `면접 ${item.interviewId}`,
          updated_at:
            item.updatedAt || item.createdAt || new Date().toISOString(),
          is_completed: item.status === "completed",
          isClicked: false,
          isEdit: false,
        }));

        // 클라이언트 측 페이지네이션
        const startIdx = (listPage.offset - 1) * listPage.limit;
        const endIdx = startIdx + listPage.limit;
        const pagedData = newData.slice(startIdx, endIdx);

        console.log("[소크라테스 V2] 변환된 데이터:", newData);
        console.log("[소크라테스 V2] 페이지 데이터:", pagedData);

        if (listPage.offset > 1) {
          setList((prev) => {
            const uniqueData = pagedData.filter(
              (newItem) =>
                !prev.some((existingItem) => existingItem.id === newItem.id)
            );
            return [...prev, ...uniqueData];
          });
        } else {
          setList(pagedData);
        }
        setCurrentUrl(url);

        setListPage((prev) => ({
          ...prev,
          total: newData.length,
        }));
      } catch (error) {
        console.error("소크라테스 목록 조회 실패:", error);
      }
      setIsUpdateList(false);
      return;
    }

    // 튜터 모드: 기존 레거시 API 사용
    // user.id가 없으면(미로그인/세션만료) 401이 나므로 호출하지 않음
    if (!isValidLogin()) {
      console.log("[Nav] 튜터 모드: user.id 없음, API 호출 스킵");
      setIsUpdateList(false);
      return;
    }
    const data = `?offset=${listPage.offset}&limit=${listPage.limit}`;
    const groupData = await touchAPI("GET", url, data);
    if (groupData) {
      const newData = groupData?.group_list?.map((item) => ({
        ...item,
        isClicked: false,
        isEdit: false,
      }));
      if (newData) {
        // setList(newData);
        if (listPage.offset > 1) {
          setList((prev) => {
            // 중복된 데이터 제거
            const uniqueData = newData.filter(
              (newItem) =>
                !prev.some((existingItem) => existingItem.id === newItem.id)
            );
            return [...prev, ...uniqueData];
          });
        } else {
          setList(newData);
        }
        setCurrentUrl(url); // Update the current URL
      }
      setListPage((prev) => ({
        ...prev,
        total: groupData?.total_count,
      }));
    }
    setIsUpdateList(false);
  };

  const logout = async () => {
    const response = await backIncstance("GET", URLS.LOGOUT);
    try {
      if (response.status === 200) {
        setUser((prev) => ({
          ...prev,
          id: null,
          tone: null,
          picture_extension: null,
          picture_data: null,
          name: null,
          paid: false,
          start_dt: null,
          end_dt: null,
          tutor_cnt: 0,
          socra_cnt: 0,
        }));
        sessionStorage.removeItem("userInfo");
        sessionStorage.removeItem("item");
        setHistory([]);
        setList([]);
        setStoredList([]);
        navigation("/");
      } else {
        setAlertSetting((prev) => ({
          ...prev,
          alertTxt: "다시 시도해주세요.",
          btnTxt: "닫기",
        }));
      }
    } catch {
      setAlertSetting((prev) => ({
        ...prev,
        alertTxt: "다시 시도해주세요.",
        btnTxt: "닫기",
      }));
    }
  };

  const handleConfirm = () => {
    setAlertSetting((prev) => ({
      ...prev,
      alertTxt: "로그아웃 하시겠습니까?",
      double: true,
      btnTxt: "로그아웃",
      onConfirm: () => {
        if (typeof prev.onConfirm === "function") {
          prev.onConfirm();
        }
        logout();
        if (window.Android?.logout) window.Android.logout();
      },
    }));
  };
  const getStorageList = async (url) => {
    const data = `?offset=${storagePage.offset}&limit=${storagePage.limit}`;
    const storageData = await touchAPI("GET", url, data);
    if (storageData) {
      if (storagePage.offset > 1) {
        setStoredList((prev) => {
          // 중복된 데이터 제거
          const uniqueData = storageData.filter(
            (newItem) =>
              !prev.some((existingItem) => existingItem.id === newItem.id)
          );
          return [...prev, ...uniqueData];
        });
      } else {
        setStoredList(
          storageData.storage_list.map((item) => ({
            ...item,
            isEdit: false,
            isClicked: false,
          }))
        );
      }
      setStoragePage((prev) => ({
        ...prev,
        total: storageData.total_count,
      }));
    }
  };
  useEffect(() => {
    // if (isMobile) {
    document.addEventListener("mousedown", handleOutsideClick);
    // }
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [openNav, handleOutsideClick]);

  useEffect(() => {
    const data = location.pathname.split("/");

    const params = data[2];
    const path = data[1];
    const mode = location.state;

    setPathSegments(location.pathname.split("/"));

    let targetPoint;
    if (path === "socrates" || path === "result") {
      targetPoint = SOCRATES_URLS;
    } else if (path === "mypage") {
    } else if (path === "guide") {
    } else {
      targetPoint = TUTOR_URLS;
    }
    if (targetPoint) {
      if (targetPoint.GROUP_LIST !== endpoint.GROUP_LIST) {
        setListPage({
          offset: 1,
          limit: 10,
          total: null,
        });
        setStoragePage({
          offset: 1,
          limit: 10,
          total: null,
        });
      }
      setEndpoint(targetPoint);
    }

    const isChat =
      path === "" ||
      path.indexOf("tutor") !== -1 ||
      path.indexOf("socrates") !== -1 ||
      path.indexOf("result") !== -1
        ? true
        : false;

    // 현재 채팅 상태 업데이트
    if (!isChat) {
      setCurrentChatState({
        // chat 이 아닐 경우 상태만 저장
        isChat: isChat,
        path: currentChatState.path, // 기존 chat path 유지
      });
      return;
    } else {
      setCurrentChatState({
        // chat 일 경우 현재 path 도 저장
        isChat: isChat,
        path: path,
      });
    }
    if (!isChat) return;

    // touchAPI('GET', targetPoint.STORAGE_LIST, `?offset=${storagePage.offset}&limit=${storagePage.limit}`)
    getStorageList(targetPoint.STORAGE_LIST);
    getGroupList(targetPoint.GROUP_LIST);

    let targetList = list?.filter((item) => item.id === Number(params));
    if (Array.isArray(targetList) && targetList.length === 0) {
      // storedList를 순회하여 값을 찾습니다.
      targetList = storedList?.filter((item) => item.id === Number(params));
    }
    let targetName = mode?.target;
    if (params) {
      // 튜터 새 채팅시 history 배열 초기화 방지
      if (targetName === "new") return;
    } else {
      setHistory([]);
      // navigation('/')
      // window.localStorage.removeItem('url')
    }
    listRef.current = Array(list?.length).fill(null);
    storedRef.current = Array(storedList?.length).fill(null);
  }, [location, user]);

  const fetchData = (target) => {
    if (target === "list") {
      setListPage((prev) => ({
        ...prev,
        offset: prev.offset + 1,
      }));
    } else {
      setStoragePage((prev) => ({
        ...prev,
        offset: prev.offset + 1,
      }));
    }
  };

  // 채팅 목록/보관함 목록 페이징 변경시 목록 조회 API 호출

  useEffect(() => {
    // isUpdateList가 true일 때 또는 페이지 오프셋 변경 시 목록 갱신
    if (isUpdateList || listPage.offset > 0) {
      console.log(
        "[Nav] useEffect 트리거: isUpdateList=",
        isUpdateList,
        "user.id=",
        user?.id
      );
      getGroupList(endpoint.GROUP_LIST);
    }
  }, [listPage.offset, isUpdateList, user?.id]);

  useEffect(() => {
    getStorageList(endpoint.STORAGE_LIST);
  }, [storagePage.offset]);

  /**
   * warning Handler
   */
  const clearWarnState = () => {
    setWarnSetting({
      ...warnSetting,
      warningTxt: "",
    });
    setIsWarning(false);
  };
  const [isWarning, setIsWarning] = useState(false);
  const [warnSetting, setWarnSetting] = useState({
    warningTxt: "",
    onClose: () => clearWarnState(),
  });
  useEffect(() => {
    if (warnSetting.warningTxt !== "") {
      setIsWarning(true);
    }
  }, [warnSetting.warningTxt]);

  return (
    <Style open={openNav} mobile={`${isMobile}`}>
      <div
        key={location?.pathname}
        className={`${
          openNav && isMobile
            ? "modal"
            : isMobile
            ? "cursor-pointer"
            : "h-navHeight"
        } `}
      >
        {
          // 마이페이지가 아닐 경우 대화 목록
          !isProfile ? (
            <div
              className={`nav-wrp flex absolute flex-col ${
                isMobile ? "h-full" : "h-navHeight "
              } ${openNav ? "open" : "closed"} `}
              ref={modalRef}
            >
              <div className="nav-top">
                {isMobile && (
                  <div className="nav-top__logo flx-box">
                    <img
                      src="https://img.dongascience.com/air/icon_logo.svg"
                      alt="logo-img"
                    />
                  </div>
                )}
                {isValidLogin() && (
                  <div
                    className="nav-top__add-btn flx-box crs-btn"
                    onClick={() => !fetching && handleLeave()}
                  >
                    <img src={Plus} alt="add-chat" />
                    <span>
                      {endpoint.CHAT_HISTORY === TUTOR_URLS.CHAT_HISTORY
                        ? "새 튜터"
                        : "소크라테스 만들기"}
                    </span>
                  </div>
                )}
              </div>
              <div className="nav-middle" key={endpoint.CHAT_HISTORY}>
                <div className="nav-middle__list">
                  <div
                    className="flx-box sep-elm crs-btn new-grp"
                    onClick={() => setIsShowRecent(!isShowRecent)}
                  >
                    <div className="flx-box">
                      <img className="nav-list-img" src={History} alt="" />
                      <p>
                        {endpoint.CHAT_HISTORY === TUTOR_URLS.CHAT_HISTORY
                          ? "튜터 목록"
                          : "소크라테스 목록"}
                      </p>
                    </div>
                    <img
                      src={Toggle}
                      className={`tgl-btn ${isShowRecent ? "reverse" : ""}`}
                      alt="toggle-list"
                    />
                  </div>
                  <InfiniteScroll
                    dataLength={list?.length}
                    next={() => fetchData("list")}
                    hasMore={
                      listPage.total <= listPage.limit * listPage.offset
                        ? false
                        : true
                    }
                    // hasMore={true}
                    scrollableTarget="scrollableDiv"
                    key={endpoint.GROUP_LIST}
                  >
                    {isShowRecent && (
                      <ul
                        className="nav-middle__tgl-box"
                        id="scrollableDiv"
                        ref={listScrollRef}
                      >
                        {list?.length !== 0 &&
                          list?.map((newItem, newIdx, array) => {
                            const today = new Date();
                            const updatedAt = new Date(newItem.updated_at);
                            const day = 24 * 60 * 60 * 1000;

                            // 날짜만 비교하기 위해 시간 정보를 제거
                            today.setHours(0, 0, 0, 0);
                            updatedAt.setHours(0, 0, 0, 0);

                            const diffDays = Math.floor(
                              (today - updatedAt) / day
                            );

                            let section = null;

                            // 섹션 결정 로직
                            const currentSection = (() => {
                              if (diffDays === 0) {
                                return "today";
                              } else if (diffDays >= 1 && diffDays <= 7) {
                                return "last7days";
                              } else if (diffDays > 7 && diffDays <= 14) {
                                return "last14days";
                              } else {
                                return `${updatedAt.getFullYear()}-${
                                  updatedAt.getMonth() + 1
                                }`;
                              }
                            })();

                            const prevItem = array[newIdx - 1];
                            const prevSection = prevItem
                              ? (() => {
                                  const prevUpdatedAt = new Date(
                                    prevItem.updated_at
                                  );
                                  prevUpdatedAt.setHours(0, 0, 0, 0);
                                  const prevDiffDays = Math.floor(
                                    (today - prevUpdatedAt) / day
                                  );

                                  if (prevDiffDays === 0) {
                                    return "today";
                                  } else if (
                                    prevDiffDays >= 1 &&
                                    prevDiffDays <= 7
                                  ) {
                                    return "last7days";
                                  } else if (
                                    prevDiffDays > 7 &&
                                    prevDiffDays <= 14
                                  ) {
                                    return "last14days";
                                  } else {
                                    return `${prevUpdatedAt.getFullYear()}-${
                                      prevUpdatedAt.getMonth() + 1
                                    }`;
                                  }
                                })()
                              : null;

                            // 현재 섹션이 이전 섹션과 다를 때만 섹션 헤더 렌더링
                            if (currentSection !== prevSection) {
                              if (currentSection === "today") {
                                section = <h1 key="section-today">오늘</h1>;
                              } else if (currentSection === "last7days") {
                                section = (
                                  <h1 key="section-last7days">지난 7일</h1>
                                );
                              } else {
                                section = (
                                  <h1
                                    key={`section-${updatedAt.getMonth()}-${updatedAt.getFullYear()}`}
                                  >
                                    {`${updatedAt.getFullYear()}년 ${
                                      updatedAt.getMonth() + 1
                                    }월`}
                                  </h1>
                                );
                              }
                            }

                            return (
                              <React.Fragment key={newItem.id}>
                                {section}
                                <li
                                  ref={(el) => (listRef.current[newIdx] = el)}
                                  key={`${pageName}-${newItem.id}-${newItem.updated_at}`}
                                  id={newItem.id}
                                  className={`${
                                    !newItem.isEdit ? "crs-btn" : ""
                                  }`}
                                >
                                  <div
                                    className={`conv-his flx-box sep-elm ${
                                      newItem.id === Number(paramId)
                                        ? "selected"
                                        : ""
                                    }`}
                                  >
                                    <p style={{ lineHeight: "35px" }}>{`• `}</p>
                                    <input
                                      onClick={(e) =>
                                        !fetching &&
                                        handleClickNav(e, "group", newItem)
                                      }
                                      className={`inp-tt ${
                                        newItem.isEdit ? "focus" : ""
                                      }`}
                                      defaultValue={newItem.title}
                                      ref={(el) =>
                                        (titleRefs.current[newIdx] = el)
                                      }
                                      readOnly={!newItem.isEdit}
                                      onBlur={(e) =>
                                        newItem.isEdit &&
                                        handleBlur("group", e, newIdx, newItem)
                                      }
                                      onKeyDown={(e) =>
                                        checkKeyType(
                                          "group",
                                          e,
                                          newIdx,
                                          newItem
                                        )
                                      }
                                    />
                                    <img
                                      id="chat-more-btn"
                                      src={More}
                                      alt="edit-list"
                                      className="more-icon crs-btn"
                                      onClick={(e) => {
                                        handleClickItem("group", e, newIdx);
                                      }}
                                    />
                                    {newItem.isClicked && (
                                      <div className="hv-box" key={newItem.id}>
                                        {HOVER_OPTIONS.map(
                                          (hoverItem, hoverIdx) => (
                                            <div
                                              id="chat-more-btn-title"
                                              onClick={() =>
                                                handleEditList(
                                                  "group",
                                                  newItem,
                                                  hoverItem,
                                                  newIdx
                                                )
                                              }
                                              className="hover-modal flx-box crs-btn"
                                              key={`${newItem.id}-hover-${hoverIdx}`}
                                              ref={(el) =>
                                                (moreRef.current[newIdx] = el)
                                              }
                                            >
                                              <img
                                                className="edit-list crs-btn"
                                                src={hoverItem.ICON}
                                              />
                                              <p className="flex-1">
                                                {hoverItem.NAME}
                                              </p>
                                            </div>
                                          )
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </li>
                              </React.Fragment>
                            );
                          })}
                      </ul>
                    )}
                  </InfiniteScroll>

                  {/* 채팅 보관함 start - 소크라테스 모드에서는 숨김 */}
                  {endpoint.CHAT_HISTORY === TUTOR_URLS.CHAT_HISTORY && (
                    <div
                      className="flx-box sep-elm crs-btn new-grp"
                      onClick={() => setIsShowList(!isShowList)}
                    >
                      <div className="flx-box">
                        <img className="nav-list-img" src={Storage} alt="" />
                        <p>
                          {endpoint.CHAT_HISTORY === TUTOR_URLS.CHAT_HISTORY
                            ? "튜터 보관함"
                            : "소크라테스 보관함"}
                        </p>
                      </div>
                      <img
                        src={Toggle}
                        className={`tgl-btn ${isShowList ? "reverse" : ""}`}
                        alt="toggle-list"
                      />
                    </div>
                  )}
                  {endpoint.CHAT_HISTORY === TUTOR_URLS.CHAT_HISTORY && (
                    <InfiniteScroll
                      dataLength={storedList?.length}
                      next={() => fetchData("storage")}
                      hasMore={
                        storagePage.total <=
                        storagePage.limit * storagePage.offset
                          ? false
                          : true
                      }
                      key={endpoint.STORAGE_LIST}
                      scrollableTarget="scrollableStorage"
                    >
                      {isShowList && (
                        <ul
                          className="nav-middle__tgl-box"
                          id="scrollableStorage"
                          ref={storageScrollRef}
                        >
                          {storedList?.length !== 0 &&
                            storedList.map((storedItem, storedIdx, array) => {
                              const today = new Date();
                              const updatedAt = new Date(storedItem.updated_at);
                              const day = 24 * 60 * 60 * 1000;

                              // 날짜만 비교하기 위해 시간 정보를 제거
                              today.setHours(0, 0, 0, 0);
                              updatedAt.setHours(0, 0, 0, 0);

                              const diffDays = Math.floor(
                                (today - updatedAt) / day
                              );

                              let section = null;

                              // 섹션 결정 로직
                              const currentSection = (() => {
                                if (diffDays === 0) {
                                  return "today";
                                } else if (diffDays >= 1 && diffDays <= 7) {
                                  return "last7days";
                                } else if (diffDays > 7 && diffDays <= 14) {
                                  return "last14days";
                                } else {
                                  return `${updatedAt.getFullYear()}-${
                                    updatedAt.getMonth() + 1
                                  }`;
                                }
                              })();

                              const prevItem = array[storedIdx - 1];
                              const prevSection = prevItem
                                ? (() => {
                                    const prevUpdatedAt = new Date(
                                      prevItem.updated_at
                                    );
                                    prevUpdatedAt.setHours(0, 0, 0, 0);
                                    const prevDiffDays = Math.floor(
                                      (today - prevUpdatedAt) / day
                                    );

                                    if (prevDiffDays === 0) {
                                      return "today";
                                    } else if (
                                      prevDiffDays >= 1 &&
                                      prevDiffDays <= 7
                                    ) {
                                      return "last7days";
                                    } else if (
                                      prevDiffDays > 7 &&
                                      prevDiffDays <= 14
                                    ) {
                                      return "last14days";
                                    } else {
                                      return `${prevUpdatedAt.getFullYear()}-${
                                        prevUpdatedAt.getMonth() + 1
                                      }`;
                                    }
                                  })()
                                : null;

                              // 현재 섹션이 이전 섹션과 다를 때만 섹션 헤더 렌더링
                              if (currentSection !== prevSection) {
                                if (currentSection === "today") {
                                  section = <h1 key="section-today">오늘</h1>;
                                } else if (currentSection === "last7days") {
                                  section = (
                                    <h1 key="section-last7days">지난 7일</h1>
                                  );
                                } else {
                                  section = (
                                    <h1
                                      key={`section-${updatedAt.getMonth()}-${updatedAt.getFullYear()}`}
                                    >
                                      {`${updatedAt.getFullYear()}년 ${
                                        updatedAt.getMonth() + 1
                                      }월`}
                                    </h1>
                                  );
                                }
                              }

                              return (
                                <React.Fragment key={storedItem.id}>
                                  {section}
                                  <li
                                    className={`${
                                      !storedItem.isEdit ? "crs-btn" : ""
                                    }`}
                                    ref={(el) =>
                                      (storedRef.current[storedIdx] = el)
                                    }
                                    id={storedItem.id}
                                    key={`${pageName}-${storedItem.id}-${storedItem.updated_at}-${storedIdx}`}
                                  >
                                    <div
                                      className={`conv-his flx-box sep-elm ${
                                        storedItem.id === Number(paramId)
                                          ? "selected"
                                          : ""
                                      }`}
                                    >
                                      <p
                                        style={{ lineHeight: "35px" }}
                                      >{`• `}</p>
                                      <input
                                        onClick={(e) =>
                                          !fetching &&
                                          handleClickNav(
                                            e,
                                            "storage",
                                            storedItem
                                          )
                                        }
                                        className={`inp-tt ${
                                          storedItem.isEdit ? "focus" : ""
                                        }`}
                                        defaultValue={storedItem.title}
                                        ref={(el) =>
                                          (storefTitleRefs.current[storedIdx] =
                                            el)
                                        }
                                        readOnly={!storedItem.isEdit}
                                        onKeyDown={(e) =>
                                          storedItem.isEdit &&
                                          checkKeyType(
                                            "storage",
                                            e,
                                            storedIdx,
                                            storedItem
                                          )
                                        }
                                        onBlur={(e) =>
                                          storedItem.isEdit &&
                                          handleBlur(
                                            "storage",
                                            e,
                                            storedIdx,
                                            storedItem
                                          )
                                        }
                                      />
                                      <img
                                        id="chat-more-btn"
                                        src={More}
                                        alt="edit-list"
                                        className="more-icon crs-btn"
                                        onClick={(e) => {
                                          handleClickItem(
                                            "storage",
                                            e,
                                            storedIdx
                                          );
                                        }}
                                      />
                                      {storedItem.isClicked && (
                                        <div
                                          className="hv-box"
                                          key={storedItem.id}
                                        >
                                          {HOVER_OPTIONS.map(
                                            (sHoverdItrem, shoverIdx) => {
                                              if (
                                                sHoverdItrem.NAME ===
                                                "이력 보관"
                                              ) {
                                                return null; // 건너뛰기
                                              }
                                              return (
                                                <div
                                                  id="chat-more-btn-title"
                                                  className="hover-modal flx-box crs-btn"
                                                  key={`${storedItem.id}-hover-${shoverIdx}`}
                                                  ref={(el) =>
                                                    (editRef.current[
                                                      storedIdx
                                                    ] = el)
                                                  }
                                                  onClick={() =>
                                                    handleEditList(
                                                      "storage",
                                                      storedItem,
                                                      sHoverdItrem,
                                                      storedIdx
                                                    )
                                                  }
                                                >
                                                  <img
                                                    className="edit-list"
                                                    src={sHoverdItrem.ICON}
                                                  />
                                                  <p className="flex-1">
                                                    {sHoverdItrem.NAME}
                                                  </p>
                                                </div>
                                              );
                                            }
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </li>
                                </React.Fragment>
                              );
                            })}
                        </ul>
                      )}
                    </InfiniteScroll>
                  )}
                  {/* 채팅 보관함 end */}
                </div>
              </div>
              {isMobile && (
                <ul className="nav-bottom flx-box sep-elm">
                  <li
                    className="hd-wrp__st__it crs-btn"
                    onClick={() => {
                      isValidLogin() ? handleConfirm() : moveToLogin();
                    }}
                  >
                    <img src={Login} className="hd-lk" alt="" />
                  </li>
                  <li className="flx-box">
                    {/* 가이드 버튼 */}
                    <div
                      className="hd-wrp__st__it crs-btn"
                      onClick={() =>
                        handleClickLink("guide", "/guide/main", true)
                      }
                      style={{ position: "relative", marginRight: "13px" }}
                    >
                      <img src={GuideIcon} className="hd-lk" alt="guide" />
                      {/* ISEVENT 배지 */}
                      {/* <span className="event-badge">
                        <img src={GuideEvent} alt="EVENT" style={{ width: '100%', height: '100%' }} />
                      </span> */}
                      {/* ISNEW 배지 */}
                      {/* <span className="new-badge">
                        <img src={GuideNew} alt="NEW" style={{ width: '100%', height: '100%' }} />
                      </span> */}
                    </div>

                    <a
                      className="hd-wrp__st__it crs-btn"
                      href={`${process.env.REACT_APP_DONGA_STORE}/product/gzs7BGyv`}
                      target={isAppMode ? "_blank" : undefined}
                      rel={isAppMode ? "noreferrer" : undefined}
                      // onClick={() => handleClickLink('요금제 안내', '/settings/products')}
                    >
                      <img
                        style={{
                          marginRight: "13px",
                        }}
                        src={Products}
                        className="hd-lk"
                        alt=""
                      />
                    </a>

                    <div
                      className="hd-wrp__st__it crs-btn"
                      onClick={() =>
                        isValidLogin()
                          ? handleClickLink("my-page", "/my-activity")
                          : moveToLogin()
                      }
                    >
                      <img src={MyActivity} className="hd-lk" alt="" />
                    </div>
                  </li>
                  {}
                </ul>
              )}
              <div className="nav-footer">
                <FooterSide />
              </div>
              {!isMobile && (
                <div
                  className={`tab-wrp flx-box crs-btn ${
                    openNav ? "open" : "closed"
                  }`}
                  onClick={() => setOpenNav(!openNav)}
                >
                  <img
                    className="tab-cls min-w-2"
                    src={OpenNav}
                    style={!openNav ? { rotate: "180deg" } : { rotate: "0deg" }}
                  />
                </div>
              )}
            </div>
          ) : (
            <div
              className={`nav-wrp flx-box ${
                openNav ? "open" : "closed"
              } md:h-full`}
              ref={modalRef}
            >
              <div className="nav-top">
                {isMobile && (
                  <div className="nav-top__logo flx-box">
                    <img
                      src="https://img.dongascience.com/air/icon_logo.svg"
                      alt="logo-img"
                    />
                  </div>
                )}
                <label
                  htmlFor="file-input"
                  className="nav-top__profile crs-btn"
                >
                  <div className="nav-top__profile crs-btn">
                    {/* <input
                      type="file"
                      id="file-input"
                      style={{ display: "none" }}
                      accept="image/*"
                      readOnly={!isValidLogin()}
                      onChange={updateProfile}
                      onClick={moveToLogin}
                    />

                    <div className="profile-img">
                      <img
                        style={
                          imageData?.picture_extension === "jpg" ||
                          imageData?.picture_extension === "jpeg"
                            ? {
                                width: "100px",
                                height: "100px",
                                borderRadius: "50%",
                              }
                            : null
                        }
                        src={
                          imageData?.picture_data &&
                          imageData?.picture_extension
                            ? `data:image/${imageData.picture_extension};base64,${imageData.picture_data}`
                            : ProfileImg
                        }
                        alt="user-profile"
                      />
                      <div className="profile-settings">
                        <img src={Settings} alt="profile-settins-btn" />
                      </div>
                    </div> */}
                    <p className="profile-name">{user.name}</p>
                  </div>
                </label>
              </div>
              <div className="nav-middle mypage-middle" style={{ padding: 0 }}>
                {MENU_LIST.map((menuItem, menuIdx) => {
                  return (
                    <div
                      onClick={(e) => handleClickMenu(e, menuItem)}
                      key={`nav-menu-${menuIdx + 1}`}
                      className={`setting-list crs-btn ${
                        paramId === menuItem.PARAM ? "selected" : ""
                      }`}
                    >
                      <p>{menuItem.NMAE}</p>
                    </div>
                  );
                })}
              </div>

              {isMobile && (
                <ul className="nav-bottom flx-box sep-elm">
                  <li
                    className="hd-wrp__st__it crs-btn"
                    onClick={() =>
                      isValidLogin() ? handleConfirm() : moveToLogin()
                    }
                  >
                    <img src={Login} className="hd-lk" alt="" />
                  </li>
                  <li className="flx-box">
                    <div
                      className="hd-wrp__st__it crs-btn"
                      onClick={() =>
                        handleClickLink("요금제 안내", "/settings/products")
                      }
                    >
                      <img
                        style={{
                          marginRight: "13px",
                        }}
                        src={Products}
                        className="hd-lk"
                        alt=""
                      />
                    </div>

                    <div
                      className="hd-wrp__st__it crs-btn"
                      onClick={() =>
                        isValidLogin()
                          ? handleClickLink("my-page", "/my-activity")
                          : moveToLogin()
                      }
                    >
                      <img src={MyPage} className="hd-lk" alt="" />
                    </div>
                  </li>
                </ul>
              )}

              {!isMobile && (
                <div
                  className={`tab-wrp flx-box cursor-pointer ${
                    openNav ? "open" : "closed"
                  }`}
                  onClick={() => setOpenNav(!openNav)}
                >
                  <img
                    className="tab-cls min-w-2 "
                    src={OpenNav}
                    style={!openNav ? { rotate: "180deg" } : { rotate: "0deg" }}
                  />
                </div>
              )}
            </div>
          )
        }

        {alertModal && <Alert settings={alertSetting} />}
        <TicketAlert />
        {
          // isLogin &&
          // <LoginModal />
        }
        {isWarning && <Warning settings={warnSetting} />}
        {loading && !isMobile && <Fetching />}
      </div>
    </Style>
  );
};
export default Nav;

// 240627 로그인 정보 가져오기
const Style = styled.div`
  // display:${(props) => (props.islogin ? "block" : "none")};
  width: ${(props) => (props.open ? "257px" : "")};
  z-index: 1;
  .tab-wrp {
    filter: brightness(0.1);
    position: absolute;
    left: ${(props) => (props.open ? "257px" : "302px")};
    writing-mode: ${(props) => (props.open ? "" : "vertical-lr")};
    padding: ${(props) => (props.open ? "2rem 1rem" : "1rem")};
    top: 50%;
    transform: translate(0, -100%);
    z-index: 1;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    color: white;
    font-weight: 700;
    img {
      rotate: -90deg;
    }
  }
  .tab-wrp:hover {
    filter: brightness(1);
  }
`;
